export function StatusBarShadow() {
  return null
}
